export const ImportModel = {
    path: '/import_models',
    name: 'import_models',
    component: () => import('@/views/ImportModel/ImportModels.vue'),
    children: [
        {
            path: '/import_models/add',
            name: 'import_models.add',
            component: () => import('@/views/ImportModel/Form/ImportModelForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/import_models/edit/:id',
            name: 'import_models.edit',
            component: () => import('@/views/ImportModel/Form/ImportModelForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/import_models/delete/:id',
            name: 'import_models.delete',
            component: () => import('@/views/ImportModel/Form/ImportModelForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/import_models/view/:id',
            name: 'import_models.view',
            component: () => import('@/views/ImportModel/Form/ImportModelForm.vue'),
            props: {viewAction: true}
        }
    ],
}